// extracted by mini-css-extract-plugin
module.exports = {"container":"hQ","item":"hR","itemDot":"hS","itemContainer":"hT","content":"hU","tabs":"hV","button":"hW"};